/**
 * Reducer/Action Types
 */

export const REQUEST_DATA = 'REQUEST_DATA';
export const RECEIVE_DATA = 'RECEIVE_DATA';
export const UPDATE_SELECTED = 'UPDATE_SELECTED';
export const FETCH_GDOC_DATA = 'FETCH_GDOC_DATA';
export const FETCH_GDOC_DATA_ERROR = 'FETCH_GDOC_DATA_ERROR';
export const FETCH_GDOC_DATA_SUCCESS = 'FETCH_GDOC_DATA_SUCCESS';



// WEBPACK FOOTER //
// ./app/config/types.js